const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var Dankort24 = function Dankort24(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      d: "M18.063 10.954c-.218-2.372-2.34-3.088-5.154-3.088H4.955a6.98 6.98 0 0 1 5.318-2.457h11.336c2.126 0 4.033.954 5.317 2.457h-5.9l-2.963 3.088zM27.36 16.369l-3.769-4.483 3.636-3.642A6.953 6.953 0 0 1 28.6 12.4a6.953 6.953 0 0 1-1.24 3.969zM8.27 10.856 7.265 13.62h4.056c1.199 0 1.562-.496 1.83-1.452.266-.945-.401-1.312-1.22-1.312H8.27zM17.917 12.786l3.134 3.96h6.03a6.98 6.98 0 0 1-5.472 2.645H10.273A6.982 6.982 0 0 1 4.8 16.746h7.086c3.555 0 5.452-1.26 6.031-3.96z",
      fill: "#E41D27",
    })
  );
};
Dankort24.defaultProps = {
  width: "32",
  height: "24",
  viewBox: "0 0 32 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
const sizeMap = {
  24: Dankort24,
};
export function Dankort(_ref) {
  let { size = "24" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["24"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'Dankort' icon. Please use one of the available sizes: '24'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
